
<div class="radio">
    <label :for="id">
        <input
            :id="id"
            type="radio"
            :name="name"
            :value="value"
            :class="className"
            :required="required"
            :disabled="disabled"
            :checked="state"
            @change="onChange"
        >

        <span class="radio__custom" />

        <span
            v-if="!!$slots.default"
            class="radio__label"
        ><slot /></span>
    </label>
</div>
